import Vue from 'vue'
import App from './App.vue'
import router from './router'

import jsPlumb from 'jsplumb'
import ElementUI from 'element-ui'
import ApiEx from './api/index'
import store from './store'
import 'amfe-flexible'

import directive from './directives/directives.js'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'

import './assets/noconvertcss/index.scss'

// import('./permission.js')

Vue.use(directive)
Vue.use(ElementUI)

Vue.prototype.$jsPlumb = jsPlumb.jsPlumb
Vue.prototype.$api = ApiEx
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
